import axios from 'axios';
import { Message } from 'element-ui';
import qs from 'qs';
import router from "../router/";
let once = 0

if(process.env.NODE_ENV === "production") axios.defaults.baseURL = process.env.API_ROOT;

axios.interceptors.request.use(
	config => {
		const token = localStorage.getItem('Authentication')
		if(token) { // 判断是否存在token，如果存在的话，则每个http header都加上token

			config.headers.Authorization = token
		}
		return config;
	},
	err => {
		return Promise.reject(err);
	});


// axios.defaults.headers.post['Content-Type'] = 'application/json';
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
	response => {
		return response;
	},
	err => {
		if(err.response) {
			switch(err.response.status) {
				case 301:
					err.message = '连接错误(301)';
					Message.error(err.response.data.message);
					router.replace({
						path: '/'
					});
					once = 0
					break;
				case 400:
					err.message = '请求错误(400)';
					Message.error(err.message);
					once = 0
					break;
				case 401:
					once++;
					if(once == 1) {
						err.message = '未授权，请重新登录';
						setTimeout(function() {
							Message.error(err.message);
						}, 1000)
					}

					router.replace({
						path: '/login',
						query: {
							redirect: router.currentRoute.fullPath
						} //登录成功后跳入浏览的当前页面
					})

					break;
				case 403:
					err.message = '拒绝访问(403)';
					Message.error(err.message);
					once = 0

					break;
				case 404:
					err.message = `请求出错(404)`;
					Message.error(err.message);
					once = 0

					break;
				case 408:
					err.message = '请求超时(408)';
					Message.error(err.message);
					once = 0

					break;
				case 500:
					err.message = '服务器错误(500)';
					Message.error(err.message);
					once = 0
					break;
				case 501:
					err.message = '服务未实现(501)';
					Message.error(err.message);
					break;
				case 502:
					err.message = '网络错误(502)';
					Message.error(err.message);
					break;
				case 503:
					err.message = '服务不可用(503)';
					Message.error(err.message);
					break;
				case 504:
					err.message = '网络超时(504)';
					Message.error(err.message);
					break;
				case 505:
					err.message = 'HTTP版本不受支持(505)';
					Message.error(err.message);
					break;
				default:
					err.message = `连接出错(${err.response.status})!`;
					Message.error(err.message);

			}
		}
		Message.error('请求超时');
		return Promise.reject(err) //请求错误时，直接结束

		//return Promise.resolve(error);//请求错误时，不会直接结束，将会继续传到then里面,无论请求成功还是失败，在成功的回调中都能收到通知

	});




/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, params).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err.data);
		})
	});
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, params) {
	return new Promise((resolve, reject) => {
		try {
			axios.post(url, qs.stringify(params))
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err.data)
					Message.error('請求超時,请刷新重试...');
				})
		} catch(err) {
			Message.error('請求超時...');
		}
	});
}

// 检查状态码
function checkStatus(res) {
	// 结束
	if(res.status === 200 || res.status === 304) {
		return res.data
	}
	return {
		code: 0,
		msg: res.data.msg || res.statusText,
		data: res.statusText
	}
	return res
}


export default axios


// WEBPACK FOOTER //
// ./src/api/http.js